import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { injectIntl } from 'react-intl';

import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { Select, Button } from 'Components';
import { NotificationManager } from 'Components/Notifications';

import {
    mapGeofenceGroupOpenDeleteModal,
    mapGeofenceDeleteGeofenceGroup,
    //updateLandmarkGroupInRedux,
    getGeofenceGroups,
    clearRedux
} from 'Redux/actions';


const GeofenceGroupDelete = (props) => {
  const dispatch = useDispatch();
  const { intl } = props;
  const { messages } = intl;

  const {
    open,
    geofenceGroups: selectedGeofencesGroup,
    response,
    loadingResponse
  } = useSelector((state) => state.realtimeMapGeofenceGroupDeleteModuleRedux);

  const { geofencesGroups, loadingGeofenceGroup } = useSelector((state) => state.realtimeMapNewGeofenceModuleRedux);
  
  const [geofenceGroup, setGeofenceGroup] = useState();
  const [landmarkGroupList, setLandmarkGroupList] = useState([]);

  useEffect(() => {
    return () => {
      dispatch(clearRedux("MAP_GEOFENCE_DELETE_GEOFENCE_GROUP"));
    }
  }, []);

  useEffect(() => {
    if (open && geofencesGroups?.length && selectedGeofencesGroup?.length) {
      let newLandmarkGroups = geofencesGroups.map((item) => {
        return {
          ...item,
          name: `${messages['mapGeofenceDeleteGeofenceGroup_move']} ${item.name}`
        }
      });

      const groupIds = selectedGeofencesGroup.map(selectedLandmarkGroup => {
        return selectedLandmarkGroup?.id;
      });

      newLandmarkGroups = newLandmarkGroups.filter(item => !groupIds.includes(item.id));
      setLandmarkGroupList([...newLandmarkGroups, { id: 0, name: messages['mapGeofenceDeleteGeofenceGroup_deleteAll'] }]);
      setGeofenceGroup(newLandmarkGroups[0]);
    }
  }, [open, geofencesGroups, selectedGeofencesGroup]);

  useEffect(() => {
    if (response && open) {
      if (response.error) {
        NotificationManager.error(
          response.message || messages['errorMessage'],
          messages['error'],
          3000,
          null,
          null,
          'warning',
        );
        dispatch(clearRedux("MAP_GEOFENCE_DELETE_GEOFENCE_GROUP", { response: null }));
      } else {
        NotificationManager.success(
          messages['mapGeofenceDeleteGeofenceGroup_success'],
          messages['success'],
          3000,
          null,
          null,
          'success',
        );

        //dispatch(updateLandmarkGroupInRedux("remove", [...geofencesGroups]));
        dispatch(getGeofenceGroups());
        handleClose();
      }
    }
  }, [response, open]);

  const handleClose = useCallback(() => {
    dispatch(mapGeofenceGroupOpenDeleteModal(false));
    dispatch(clearRedux("MAP_GEOFENCE_DELETE_GEOFENCE_GROUP"));
  });

  return (
    <Modal
      title={messages["mapGeofenceDeleteGeofenceGroup_title"]}
      open={open}
      position="right"
      size="small"
      className="modal-top-0"
      headerStyle={{
        top: 0
      }}
      handleClose={handleClose}
    >
      <ModalBody>
        <div style={{ padding: '18px 24px 24px 24px', height: 650 }}>

          <p>{messages['mapGeofenceDeleteGeofenceGroup_question1']}</p>
          <ul>
            {selectedGeofencesGroup.map((selectedLandmarkGroup, key) => {
              return (
                <li key={key}>{selectedLandmarkGroup?.name}</li>
              )
            })}
          </ul>

          <div style={{ zIndex: 10 }}>
            <Select
              id="geofenceGroup"
              label={messages['mapGeofenceDeleteGeofenceGroup_deleteAction']}
              value={geofenceGroup}
              onChange={(value) => setGeofenceGroup(value)}
              options={landmarkGroupList}
              loading={loadingGeofenceGroup}
              textField="name"
              valueField="id"
              placeholder={messages['mapGeofenceDeleteGeofenceGroup_deleteAction']}
            />
          </div>

          <div>
            <p>{messages['mapGeofenceDeleteGeofenceGroup_question2']}</p>
            <p>{messages['mapGeofenceDeleteGeofenceGroup_warning']}</p>
          </div>
        </div>
      </ModalBody>

      <ModalFooter style={{ bottom: 50 }}>
        <Button
          disabled={loadingResponse}
          onClick={handleClose}
          className="btn-cancel"
        >
          {messages['cancel']}
        </Button>

        <Button
          disabled={loadingResponse}
          onClick={(e) => {
            if (e) e.preventDefault();
            dispatch(mapGeofenceDeleteGeofenceGroup(
              selectedGeofencesGroup?.map(selectedLandmarkGroup => {
                return selectedLandmarkGroup?.id
              }),
              geofenceGroup?.id
            ));
          }}
          className="btn-red"
        >
          {messages['delete']}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default injectIntl(GeofenceGroupDelete);